import { useQuery } from "@tanstack/react-query";
import { getMonograph } from "../api/monograph";
import type { MonographSection } from "../types";

export function useMonograph(projectId: string | undefined, enabled = true) {
  return useQuery<MonographSection[]>({
    queryKey: ["monograph", projectId],
    queryFn: () => getMonograph(projectId!),
    enabled: !!projectId && enabled,
    staleTime: 10_000,
  });
}
